import PocketBase from 'pocketbase';

// Mettez ici l'URL de votre serveur PocketBase
// Assurez-vous qu'elle correspond exactement à ce qui est affiché dans votre terminal
const POCKETBASE_URL = 'https://maisonquinard.infocolab.online';

const pb = new PocketBase(POCKETBASE_URL);

// Disable auto-cancellation to avoid "The request was autocancelled" errors 
// when multiple components fetch data simultaneously.
pb.autoCancellation(false);

export default pb;
